import {FaStar} from "react-icons/fa";
import {FiStar} from "react-icons/fi";
export const NeoRatingStar: React.FC<any> = ({data, uid}) => {
  const starRating = data[uid] ? data[uid] : 0;
  return (
    <>
      <div className="flex items-center gap-1 pt-3">
        {[0, 1, 2, 3, 4].map(i => (
          <span key={i}>
            {i < starRating ? (
              <FaStar className="text-amber-500" />
            ) : (
              <FiStar className="text-amber-500" />
            )}
          </span>
        ))}
      </div>
    </>
  );
};
